import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-role-master",
  templateUrl: "./role-master.component.html",
  styleUrls: ["./role-master.component.css"]
})
export class RoleMasterComponent implements OnInit {
  searchlist: boolean = true;
  showList: boolean = false;
  screentitle: string = "Role Management";
  actionmode: string = "Seacrh";
  parent_table = "mst_role";
  childtables = ["mst_functionality", "mst_role_access"];
  parent_table_ID = "ROLE_ID";
  child_table_ID = "FUN_ID";
  Parent_result_ID = "";
  formData: any = [];
  filters = [];
  childtable = [];

  ROLE_NAME = "ROLE_NAME";
  ROLE_DESCRIPTION = "ROLE_DESCRIPTION";
  loader: any = false;
  APPROVAL_STATUS = "APPROVAL_STATUS";
  dbFields = [this.ROLE_NAME, this.ROLE_DESCRIPTION, this.APPROVAL_STATUS];
  dbField = [this.ROLE_NAME, this.ROLE_DESCRIPTION];
  dbFieldsChild = [this.parent_table_ID, this.child_table_ID];
  searchitem = " ";
  searchColumn = " ";
  timer;

  checkbox_details: any = [];
  checkboxId: any = [];
  addData: any = [];
  viewData: any = [];
  editData: any = [];
  aprData: any = [];
  role_search_details: any = [];

  role_screen_details: any = [];

  serachtabledata: any = [];
  data: any = [];
  status: any = {};
  p: number = 1;
  deleteCheckBox: any = [];

  APPROVAL_REMARKS = "APPROVAL_REMARKS";
  APPROVAL_BY = "APPROVAL_BY";
  aprove_details: any = [];
  uid = "";
  aprovebtn: boolean = true;
  rejectbtn: boolean = true;
  roleID = "";
  fid = "";
  RAC_VIEW = "";
  RAC_ADD = "";
  RAC_EDIT = "";
  RAC_APROVE = "";
  parentFun = [];
  childFun = [];
  totalFun = [];
  functionalityData = [];
  AllfunctionalityData = [];
  parentTabs = [];
  functionaltyId = [];
  masterTables = [];
  lengthCheck: boolean = false;
  nameAvailable: boolean = false;
  constructor(private vernostService: VernostServiceService, private router: Router) { }

  ngOnInit() {
    this.uid = localStorage.getItem("uid");
    this.roleID = localStorage.getItem("roleID");
    this.fid = localStorage.getItem("fid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    // alert("fid"+this.fid);
    //console.log(this.fid);
    this.lengthCheck = false;
    this.nameAvailable = false;
    var rollArray_role = {
      funId: this.fid,
      roleID: this.roleID
    };
  
    this.vernostService.checkFunAccess(rollArray_role).subscribe(response => {
      this.RAC_VIEW = JSON.stringify(response[0].addinfo[0].RAC_VIEW);
      this.RAC_EDIT = JSON.stringify(response[0].addinfo[0].RAC_EDIT);
      this.RAC_ADD = JSON.stringify(response[0].addinfo[0].RAC_ADD);
      this.RAC_APROVE = JSON.stringify(response[0].addinfo[0].RAC_APROVE);
    });
    
    this.role_screen_details = {
      ROLE_NAME: "",
      ROLE_DESCRIPTION: "",
      FUN_ID: "",
      FUN_NAME: ""
    };
    this.role_search_details = {
      ROLE_NAME: "",
      ROLE_DESCRIPTION: ""
    };

    this.addCheckbox(this.childtables[0]);
  }
  addForm() {
    this.actionmode = "Add";
    this.showList = false;

    document.getElementById("ErrorDiv").innerHTML = "";
    document.getElementById("ErrorDiv").style.color = "";
  }
  searchForm() {
    this.checkbox_details = [];
    this.parentFun = [];
    this.childFun = [];
    this.totalFun = [];
    this.functionalityData = [];
    this.AllfunctionalityData = [];
    this.parentTabs = [];
    this.functionaltyId = [];
    this.masterTables = [];
    this.addCheckbox(this.childtables[0]);
    this.checkboxId = [];
    this.addData = [];
    this.viewData = [];
    this.editData = [];
    this.aprData = [];
    this.addCheckArr();
    this.actionmode = "Search";
    this.Parent_result_ID = "";
    this.role_search_details = {
      ROLE_NAME: "",
      ROLE_DESCRIPTION: ""
    };
    this.role_screen_details = {
      ROLE_NAME: "",
      ROLE_DESCRIPTION: ""
    };
    // this.searchresult = false;

    document.getElementById("ErrorDiv").innerHTML = "";
    document.getElementById("ErrorDiv").style.color = "";
  }
  checkAproval() {
    // this.aprovebtn="";
    var dbField = [this.APPROVAL_STATUS];
    var arrayRoleMaster = {
      dbField: dbField,
      parent_table: this.parent_table,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    this.vernostService.checkAproval(arrayRoleMaster).subscribe(response => {
      // alert(JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS));
      var status = JSON.stringify(response[0].addinfo[0].APPROVAL_STATUS);
      var stat = parseInt(status);
      if (stat == 1) {
        this.aprovebtn = false;
        this.rejectbtn = true;
      }
      if (stat == 2) {
        this.rejectbtn = false;
        this.aprovebtn = true;
      } else {
        this.aprovebtn = true;
        this.rejectbtn = true;
      }
    });
  }
  aproveReject(status) {
    var dbFieldRoleMaster = [
      this.APPROVAL_STATUS,
      this.APPROVAL_REMARKS,
      this.APPROVAL_BY
    ];
    var formDataRoleMaster = [status, this.aprove_details.APPROVAL_REMARKS, this.uid];
    let arrayRoleMaster = {
      dbField: dbFieldRoleMaster,
      parent_table: this.parent_table,
      formData: formDataRoleMaster,
      parent_table_ID: this.parent_table_ID,
      formdataId: this.Parent_result_ID
    };
    //console.log(array);
    this.vernostService.aproveReject(arrayRoleMaster).subscribe(res => {
      this.searchForm();
    });
  }
  addCheckbox(childtable) {
    var array = {
      childtable: childtable
    };

    this.vernostService.getCheckBoxData(array).subscribe(response => {
      //console.log("response[0].result", response[0].result);
      if (response[0].status == this.childtables[0]) {
        response[0].result.forEach(element => {
          if (
            element.FUN_ROUTER_NAME == "" ||
            element.FUN_ROUTER_NAME == null
          ) {
            this.parentFun.push(element.FUN_ID);
          } else {
            this.childFun.push(element);
          }
        });
        for (var j = 0; j < this.parentFun.length; j++) {
          response[0].result.forEach(element => {
            if (this.parentFun[j] == element.FUN_ID) {
              this.totalFun.push(element);
            }
          });
        }
        for (var i = 0; i < this.parentFun.length; i++) {
          this.checkbox_details.push({
            FUN_NAME: this.totalFun[i].FUN_NAME,
            FUN_ID: this.totalFun[i].FUN_ID,
            FUN_ROUTER_NAME: this.totalFun[i].FUN_ROUTER_NAME,
            ADD: "",
            VIEW: "",
            EDIT: "",
            APRREJ: "",
            status: false,
            status2: false,
            status3: false,
            status4: false,
            status5: false
          });
          response[0].result.forEach(element => {
            if (this.parentFun[i] == element.FUN_PARENT) {
              this.checkbox_details.push({
                FUN_NAME: element.FUN_NAME,
                FUN_ID: element.FUN_ID,
                FUN_ROUTER_NAME: element.FUN_ROUTER_NAME,
                FUN_PARENT: element.FUN_PARENT,
                ADD: "",
                VIEW: "",
                EDIT: "",
                APRREJ: "",
                status: false,
                status2: false,
                status3: false,
                status4: false,
                status5: false
              });
            }
          });
        }
      }
    });
  }

  addCheckArr() {
    // for (var i = 0; i < 4; i++) {
    //   this.addData.push("0");
    //   this.viewData.push("0");
    //   this.editData.push("0");
    //   this.aprData.push("0");
    // }
  }
  checkBoxAdd(event, i, fun, funId) {
    //console.log(i, "this.functionalityData[i][0]", this.functionalityData);

    for (var j = 0; j < this.functionalityData.length; j++) {
      // this.functionalityData[j][0];
      if (this.functionalityData[j][0] == funId) {
        //console.log("funId", funId);
        if (fun == "ADD") {
          if (event.target.checked) {
            this.functionalityData[j][1] = "1";
          } else {
            this.functionalityData[j][1] = "0";
          }
        }
        if (fun == "VIEW") {
          if (event.target.checked) {
            this.functionalityData[j][2] = "1";
          } else {
            this.functionalityData[j][2] = "0";
          }
        }
        if (fun == "EDIT") {
          if (event.target.checked) {
            this.functionalityData[j][3] = "1";
          } else {
            this.functionalityData[j][3] = "0";
          }
        }
        if (fun == "APRREJ") {
          if (event.target.checked) {
            this.functionalityData[j][4] = "1";
          } else {
            this.functionalityData[j][4] = "0";
          }
        }
      }
    }

    //console.log("this.functionalityData", this.functionalityData);
  }
  enableFun() {
    for (var i = 0; i < this.functionaltyId.length; i++) {
      var FUN_ID = this.functionaltyId[i];
      //console.log(document.getElementById("add" + FUN_ID), "show_id", FUN_ID);
      if ((document.getElementById("add" + FUN_ID) as HTMLInputElement) != undefined
        && (document.getElementById("add" + FUN_ID) as HTMLInputElement) != null) {
        (document.getElementById(
          "add" + FUN_ID
        ) as HTMLInputElement).disabled = false;
        (document.getElementById(
          "view" + FUN_ID
        ) as HTMLInputElement).disabled = false;
        (document.getElementById(
          "edit" + FUN_ID
        ) as HTMLInputElement).disabled = false;
        (document.getElementById(
          "aprove" + FUN_ID
        ) as HTMLInputElement).disabled = false;
      }
    }
  }

  showFormData(formData, toggle) {
    setTimeout(() => {
      document.getElementById("ErrorDiv").innerHTML = "";
    }, 2000);
    this.Parent_result_ID = formData;
    //console.log("this.Parent_result_ID :", this.Parent_result_ID);
    //console.log("this.parent_table_ID====", this.parent_table_ID);
    var array = {
      parent_table: this.parent_table,
      dbFields: this.dbFields,
      parent_table_ID: this.parent_table_ID,
      formData: formData
    };
    this.vernostService.getAllFuntionalityData(array).subscribe(
      response => {
        if (response[0].subqueryResult.length > 0) {
          var sub = response[0].subqueryResult;
          this.role_screen_details = {
            ROLE_NAME: response[0].result[0].ROLE_NAME,
            ROLE_DESCRIPTION: response[0].result[0].ROLE_DESCRIPTION,
            FUN_NAME: response[0].result[0].FUN_NAME,
            FUN_ID: response[0].result[0].FUN_ID
          };
          for (let j = 0; j < sub.length; j++) {
            var funid = sub[j].FUN_ID;
            for (let k = 0; k < this.checkbox_details.length; k++) {
              if (this.checkbox_details[k].FUN_ID == funid) {
                this.checkbox_details[k].status = true;
              }
            }
          }
          for (var p = 0; p < response[0].subqueryResult.length; p++) {
            if (response[0].subqueryResult[p].FUN_PARENT != 0) {
              this.parentTabs.push(response[0].subqueryResult[p].FUN_PARENT);
            }
          }
          for (var i = 0; i < response[0].subqueryResult.length; i++) {
            this.addData[i] = response[0].subqueryResult[i].RAC_ADD;
            this.editData[i] = response[0].subqueryResult[i].RAC_EDIT;
            this.aprData[i] = response[0].subqueryResult[i].RAC_APROVE;
            this.viewData[i] = response[0].subqueryResult[i].RAC_VIEW;
            var FUN_ID = sub[i].FUN_ID;
            var FUN_PARENT = sub[i].FUN_PARENT;
            if (FUN_ID != "1" || FUN_ID != "21" || FUN_ID != "23" || FUN_ID != "26") {
              this.functionaltyId.push(FUN_ID);
              if(FUN_PARENT != 0){
              this.functionalityData[i] = [
                FUN_ID,
                this.viewData[i],
                this.addData[i],
                this.editData[i],
                this.aprData[i]
              ];
            }
              this.AllfunctionalityData[i]= [
                FUN_PARENT,
                FUN_ID,
                this.viewData[i],
                this.addData[i],
                this.editData[i],
                this.aprData[i]
              ];
              
              this.checkboxId.push(FUN_ID);
            }
            for (let j = 0; j < this.checkbox_details.length; j++) {
              if (this.checkbox_details[j].FUN_ID == FUN_ID) {
                if (response[0].subqueryResult[i].RAC_ADD == "1") {
                  this.checkbox_details[j].status2 = true;
                }
                if (response[0].subqueryResult[i].RAC_VIEW == "1") {
                  this.checkbox_details[j].status3 = true;
                }
                if (response[0].subqueryResult[i].RAC_EDIT == "1") {
                  this.checkbox_details[j].status4 = true;
                }
                if (response[0].subqueryResult[i].RAC_APROVE == "1") {
                  this.checkbox_details[j].status5 = true;
                }
              }
            }
          }
          // console.log("usr_password========",response[0].result[0].usr_password);

          if (toggle == "1") {
            this.showList = true;
            this.actionmode = "Add";
          }
          if (toggle == "2") {
            this.showList = false;
            this.actionmode = "Edit";
            // this.enableFun()
            setTimeout(() => {
              this.enableFun();
            }, 2000);
          }
        } else {
          //console.log("NO RECORD FOUND");
        }
      } //
    );
  }

  checkCheckBox(event, id, parentId) {
    //console.log("********1::", event.target.checked);
    if (event.target.checked) {
      var data = event.target.value;
      //console.log(data);
      this.checkboxId.push(data);
      this.parentTabs.push(parentId);
      console.log(parentId, "********1", this.parentTabs);

      // for (var i = 0; i < this.parentTabs.length; i++) {
      //   if (this.parentTabs.indexOf(parentId) == -1) {
      //     this.parentTabs.push(parentId);
      //   }
      // }
      //console.log("this.parentTabs", this.parentTabs);
      this.functionalityData.push([id, "1", "1", "1", "0"]);
      this.AllfunctionalityData.push([parentId,id, "1", "1", "1", "0"]);
      //console.log(this.parentTabs, "checked", this.functionalityData);
      (document.getElementById(
        "add" + id
      ) as HTMLInputElement).disabled = false;
      let add = <HTMLInputElement>document.getElementById("add" + id);
      add.checked = true;
      (document.getElementById(
        "view" + id
      ) as HTMLInputElement).disabled = false;
      let view = <HTMLInputElement>document.getElementById("view" + id);
      view.checked = true;
      (document.getElementById(
        "edit" + id
      ) as HTMLInputElement).disabled = false;
      let edit = <HTMLInputElement>document.getElementById("edit" + id);
      edit.checked = true;
      (document.getElementById(
        "aprove" + id
      ) as HTMLInputElement).disabled = false;
    } else {
      //console.log("********2");
      for (let i = 0; i < this.checkboxId.length; i++) {
        if (id == this.checkboxId[i]) {
          console.log("uddd", parentId);
          this.parentTabs = this.parentTabs.filter(function (item) {
            return item !== parentId
          })
          // this.parentTabs.splice(i, 1);
          this.checkboxId.splice(i, 1);
          this.functionalityData.splice(i, 1);
          this.AllfunctionalityData.splice(i, 1);
          console.log("this.parentTabs", this.parentTabs);
          //console.log("********3", this.checkboxId);

          // for(var j=0;j<this.checkboxId.length;j++){
          //     if(this.checkboxId.length==0){
          //       console.log("vv",)
          //     }
          // }
          //console.log(this.parentTabs, "in unchecked", this.functionalityData);
          (document.getElementById(
            "add" + id
          ) as HTMLInputElement).disabled = true;
          let add = <HTMLInputElement>document.getElementById("add" + id);
          add.checked = false;
          (document.getElementById(
            "view" + id
          ) as HTMLInputElement).disabled = true;
          let view = <HTMLInputElement>document.getElementById("view" + id);
          view.checked = false;
          (document.getElementById(
            "edit" + id
          ) as HTMLInputElement).disabled = true;
          let edit = <HTMLInputElement>document.getElementById("edit" + id);
          edit.checked = false;
          (document.getElementById(
            "aprove" + id
          ) as HTMLInputElement).disabled = true;
          let aprove = <HTMLInputElement>document.getElementById("aprove" + id);
          aprove.checked = false;
        }
      }
    }
  }
  hideOne() {
    let edit = <HTMLInputElement>document.getElementById("ROLE_NAME");
    edit.style.visibility = "hidden";
  }

  submitdata() {
    this.masterTables = [];
    var rolename = this.role_screen_details.ROLE_NAME;
    var roledescription = this.role_screen_details.ROLE_DESCRIPTION;

    var childTable = this.childtables[1];
    var functionalityTable = this.childtables[0];
    this.formData = [rolename, roledescription];
    console.log("this.parentTabs", this.parentTabs);
    for (var i = 0; i < this.parentTabs.length; i++) {
      if (this.masterTables.indexOf(this.parentTabs[i]) == -1) {
        this.masterTables.push(this.parentTabs[i]);
      }
    }
    if (
      this.role_screen_details.ROLE_NAME != "" &&
      this.role_screen_details.ROLE_DESCRIPTION != "" &&
      this.nameAvailable == false
    ) {
      if (this.functionalityData.length == 0) {
        document.getElementById("ErrorDiv").innerHTML =
          "Minimum one functionality should be selected";
        document.getElementById("ErrorDiv").style.color = "#a94442";
        // document.getElementById("dataErr").style.textAlign = "center";
      } else {
        document.getElementById("ErrorDiv").innerHTML = "";
        document.getElementById("ErrorDiv").style.color = "";

        if (this.Parent_result_ID != "") {
          var FunData = [];
          var FunctionData = [];
          this.functionalityData.forEach(element => {
            if (element != null) {
              FunData.push(element);
            }
          });
         
          console.log(this.AllfunctionalityData,"FunctionData",FunData);
          var updateData = {
            Parent_result_ID: this.Parent_result_ID,
            parent_table: this.parent_table,
            dbFields: this.dbField,
            formData: this.formData,
            parent_table_ID: this.parent_table_ID,
            child_table_ID: this.child_table_ID,
            child_table: childTable,
            dbFieldsChild: this.dbFieldsChild,
            functionalityTable: functionalityTable,
            functionalityData: FunData,
            masterTables: this.masterTables
          };
          console.log("all data" + JSON.stringify(updateData));

          this.vernostService.updateRoleData(updateData).subscribe(response => {
            //console.log(JSON.stringify(response));
            if (response[0].status == "sucess") {
              //this.searchForm();
              document.getElementById("ErrorDiv").innerHTML =
                "Record Updated Successfully";
              // this.timer = setTimeout(() => {
              //   document.getElementById("ErrorDiv").innerHTML = "";
              //   document.getElementById("ErrorDiv").style.background =
              //     "#ebccd1";
              //   document.getElementById("ErrorDiv").style.color = "#a94442";
              // }, 1000);
              this.loader = false;
            } else {
              document.getElementById("ErrorDiv").innerHTML =
                response[0].message;
              document.getElementById("ErrorDiv").style.color = "#a94442";
            }
          });
        }

        if (this.Parent_result_ID == "") {
          var Data = {
            parent_table: this.parent_table,
            dbFields: this.dbField,
            formData: this.formData,
            parent_table_ID: this.parent_table_ID,
            child_table_ID: this.child_table_ID,
            child_table: childTable,
            dbFieldsChild: this.dbFieldsChild,
            functionalityTable: functionalityTable,
            functionalityData: this.functionalityData,
            masterTables: this.masterTables
          };

          //console.log("all data" + JSON.stringify(Data));

          //call webservice to save data into table
          //console.log("this.role_screen_details", this.role_screen_details);
          this.vernostService.insertRoleData(Data).subscribe(response => {
            //console.log(JSON.stringify(response));
            // alert(JSON.stringify(response));
            if (response[0].status == "sucess") {
              document.getElementById("ErrorDiv").innerHTML =
                "Record Created Successfully";
              // document.getElementById("ErrorDiv").style.color = "green";
              // setTimeout(() => {
              //   this.searchForm();
              // }, 500);
              this.showFormData(response[0].result, 1);
            } else {
              document.getElementById("ErrorDiv").innerHTML =
                response[0].message;
              document.getElementById("ErrorDiv").style.color = "#a94442";
            }
          });
        }
      }
    } else {
      document.getElementById("ErrorDiv").innerHTML = "Please fill all data";
      document.getElementById("ErrorDiv").style.color = "#a94442";
      // alert("please fill all forms details");
    }

    // this.vernostService.insertData(Data).subscribe((response) => {
    //     console.log(JSON.stringify(response))

    //   })
  }
  searchData() {
    //console.log("this.role_screen_details", this.role_screen_details);
    var field1 = this.role_search_details.ROLE_NAME;
    var field2 = this.role_search_details.ROLE_DESCRIPTION;
    //console.log("field1============" + field1);

    if (field1 != "") {
      this.searchitem = field1;
      this.searchColumn = this.ROLE_NAME;
    }
    if (field2 != "") {
      this.searchitem = field2;
      this.searchColumn = this.ROLE_DESCRIPTION;
    } else {
      this.searchitem = field1;
      this.searchColumn = this.ROLE_NAME;
    }

    //console.log(this.parent_table);
    var Data = {
      parent_table: this.parent_table,
      dbFields: this.searchColumn,
      searchData: this.searchitem,
      childtables: this.childtable,
      filters: this.filters
    };

    //console.log("all searchData Data===============>" + this.searchData);
    //console.log("all Search Data===============>" + JSON.stringify(Data));
    if (field1 != "" || field2 != "") {
      document.getElementById("ErrorDiv").innerHTML = "";
      this.loader = true;
      this.searchlist = false;
      this.vernostService.searchRoleRecord(Data).subscribe(response => {
        //console.log(JSON.stringify(response));
        this.loader = false;
        if (response.length > 0) {
          this.serachtabledata = response;
          document.getElementById("ErrorDiv").innerHTML = "";
        } else {
          document.getElementById("ErrorDiv").innerHTML = "Record Not Found";
          document.getElementById("ErrorDiv").style.color = "#a94442";
          this.serachtabledata = "";
        }
      });
    } else {
      document.getElementById("ErrorDiv").innerHTML =
        "Please apply filter to search";
      document.getElementById("ErrorDiv").style.color = "#a94442";
      this.serachtabledata = "";
    }
  }
  checkLength(data, id) {
    var namePattern = /^[A-Za-z]+$/;
    //console.log("da",data)
    if (id == 1) {
      if (data != "" && namePattern.test(data) == false) {
        document.getElementById("rolenameErr").innerHTML =
          "Accepts alphabets only";
        document.getElementById("rolenameErr").style.color = "#a94442";
      } else {
        document.getElementById("rolenameErr").innerHTML = "";
        document.getElementById("rolenameErr").style.color = "";
      }
    } else {
      if (data != "" && namePattern.test(data) == false) {
        document.getElementById("rolenameSearchErr").innerHTML =
          "Accepts alphabets only";
        document.getElementById("rolenameSearchErr").style.color = "#a94442";
        this.lengthCheck = true;
      } else {
        document.getElementById("rolenameSearchErr").innerHTML = "";
        document.getElementById("rolenameSearchErr").style.color = "";
        this.lengthCheck = false;
      }
    }
  }
  checkAvailable() {
    var array = {
      columnName: "ROLE_NAME",
      dbFieldName: this.role_screen_details.ROLE_NAME,
      parent_table: this.parent_table
    };
    //console.log("AA")
    this.vernostService.checkName(array).subscribe(data => {
      if (data[0].status == "Sucess") {
        document.getElementById("rolenameErr").innerHTML = "";
        document.getElementById("rolenameErr").style.color = "";
        this.nameAvailable = false;
      } else {
        document.getElementById("rolenameErr").innerHTML =
          "Role Name already exist";
        document.getElementById("rolenameErr").style.color = "#a94442";
        this.nameAvailable = true;
      }
    });
  }
}
